import React, { Component } from 'react';
import { connect } from 'react-redux';

class TwitterTimeline extends Component {
  componentDidMount() {
    if (typeof twttr === 'undefined') {
      const twitterscript = document.createElement('script');
      twitterscript.src = '//platform.twitter.com/widgets.js';
      twitterscript.async = true;
      twitterscript.id = 'twitter-wjs';
      document.body.appendChild(twitterscript);
    }
  }

  componentDidUpdate() {
    if (window.twttr && this.props.data.name) {
      window.twttr.widgets.load();
    }
  }

  render() {
    const { name, screen_name } = this.props.data;

    if (!screen_name) {
      return <div />;
    }

    return (
      <a
        ref="twittertimeline"
        className="twitter-timeline"
        href={`https://twitter.com/${screen_name}`}
        data-tweet-limit={25}
      >
        {name}
      </a>
    );
  }
}

function mapStateToProps(state, props) {
  return {
    id: decodeURIComponent(props.match.params.id),
    data: state.admin.resources[props.resource].data[decodeURIComponent(props.match.params.id)] || { screen_name: '' },
    isLoading: state.admin.loading > 0,
  };
}

export default connect(mapStateToProps)(TwitterTimeline);



// WEBPACK FOOTER //
// ./src/resources/ui/TwitterTimeline.js